import { useEffect, useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import FormSelectBox from "../controls/FormSelectBox";
import DropdownMenu from "../controls/DropdownMenu";

// URL API à extraire en constante si le composant PriceTypes est autonome
const PRICE_TYPES_API_URL = `${process.env.REACT_APP_API_BASE_URL}/api/PriceTypes`;

const PriceTypes = ({ id, onSelect, initialPriceTypesList, isService }) => {
  const { t, i18n } = useTranslation();
  const [selectedId, setSelectedId] = useState(id || "");
  // État local pour stocker les types de prix si non fournis par le parent
  const [localPriceTypesList, setLocalPriceTypesList] = useState([]);
  const [loading, setLoading] = useState(false);

  const listToUse =
    initialPriceTypesList && initialPriceTypesList.length > 0
      ? initialPriceTypesList
      : localPriceTypesList;

  const loadPriceTypes = async () => {
    setLoading(true);
    try {
      const response = await fetch(PRICE_TYPES_API_URL);
      if (!response.ok) {
        throw new Error("Erreur chargement types de prix");
      }
      const data = await response.json();
      setLocalPriceTypesList(data);
    } catch (error) {
      console.error("Erreur:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      setSelectedId(id);
    }
  }, [id]);

  useEffect(() => {
    if (!initialPriceTypesList || initialPriceTypesList.length === 0) {
      loadPriceTypes();
    }
  }, [initialPriceTypesList]);

  const handleChange = (name, newId) => {
    setSelectedId(newId);
    onSelect(newId);
  };

  console.log(listToUse);

  const filteredOptions = useMemo(() => {
    if (loading || listToUse.length === 0) {
      return [];
    }

    const filtered = listToUse.filter((pt) =>
      isService ? pt.isService || pt.is_service : pt.isProduct || pt.is_product
    );
    console.log(filtered);

    return filtered.map((type) => ({
      id: type.id,
      name: i18n.language.startsWith("fr") ? type.nameFr : type.nameEn,
    }));
  }, [listToUse, isService, i18n.language, loading]);

  const selectedLabel =
    filteredOptions.find((o) => `${o.id}` === `${selectedId}`)?.name || "";

  return (
    <div className="w-full">
      <label className="block text-sm font-medium text-primary">
        {t("priceType.label")}{" "}
        <span className="text-muted">{t("modal.required")}</span>
      </label>

      <DropdownMenu
        title={
          selectedLabel ||
          (loading ? t("global.loading") : t("priceType.placeholder"))
        }
        isDropdown={true}
        items={filteredOptions.map((o) => ({
          label: o.name,
          onClick: () => handleChange("priceTypeId", o.id),
        }))}
      />
    </div>
  );
};

export default PriceTypes;
